export const CELL_DATA_TYPES = {
	TEXT: 'text',
	NUMBER: 'number'
};
